import React from 'react'
import PropTypes from 'prop-types'

import { SimpleTour } from 'components'
import { Button, IonIcon } from 'controls'
import StepContainer from 'components/Tour/StepContainer'

import useTracingTour from 'components/Tour/useTracingTour'

import { tracingTourStyles } from './styles'

const lastStep = {
  selector: '.tracing-tour-container button',
  content: ({ goTo, step, close }) => (
    <StepContainer
      isLastStep
      onClose={close}
      goTo={goTo}
      nextStep={step}
      title="Siempre estaré disponible"
      description="Podrás ver esto las veces que quieras."
    />
  )
}

const ConnectedSimpleTour = ({
  tracingTourName,
  onRequestClose,
  steps,
  getCurrentStep,
  ...rest
}) => {
  const [{ isOpen }, toggleOpen] = useTracingTour(tracingTourName)

  if (!tracingTourName) {
    return null
  }

  return (
    <div className="tracing-tour-container">
      <SimpleTour
        isOpen={isOpen}
        onRequestClose={() => {
          toggleOpen(false)
          onRequestClose?.()
        }}
        steps={[...steps, lastStep]}
        getCurrentStep={getCurrentStep}
        showNavigation={false}
        disableKeyboardNavigation={['right', 'left']}
        prevButton={<span />}
        nextButton={<span />}
        {...rest}
      />

      <Button color="primary" onClick={() => toggleOpen(!isOpen)}>
        <IonIcon icon="md-help-circle-outline" style={{ margin: '0' }} />
      </Button>

      <style jsx>{tracingTourStyles}</style>
    </div>
  )
}

ConnectedSimpleTour.propTypes = {
  tracingTourName: PropTypes.string.isRequired,
  onRequestClose: PropTypes.func,
  steps: PropTypes.array.isRequired, // See reactour documentation
  getCurrentStep: PropTypes.func // See reactour documentation
}

export default ConnectedSimpleTour
